import React, { useState } from "react";
import Banking from '../../assets/Services/Ai_development/industries/Banking.jpg'
import Healthcare from '../../assets/Services/Ai_development/industries/Healthcare.jpg'
import Media from '../../assets/Services/Ai_development/industries/Media.jpg'
import Real_Estate from '../../assets/Services/Ai_development/industries/Real_Estate.jpg'
import Software_and_Technology from '../../assets/Services/Ai_development/industries/Software_and_Technology.jpg'
import Travel from '../../assets/Services/Ai_development/industries/Travel.jpg'


const CoreComponent29 = () => {
  const [healthcare, setHealthcare] = useState(true);
  const [banking, setbanking] = useState(false);
  const [software, setsoftware] = useState(false);
  const [realestate, setrealestate] = useState(false);
  const [media, setmedia] = useState(false);
  const [travel, settravel] = useState(false);

  const handleClick = () => {
    setHealthcare(true);
    setbanking(false);
    setsoftware(false);
    setrealestate(false);
    setmedia(false);
    settravel(false);
  };
  const handleClick2 = () => {
    setHealthcare(false);
    setbanking(true);
    setsoftware(false);
    setrealestate(false);
    setmedia(false);
    settravel(false);
  };
  const handleClick3 = () => {
    setHealthcare(false);
    setbanking(false);
    setsoftware(true);
    setrealestate(false);
    setmedia(false);
    settravel(false);
  };
  const handleClick4 = () => {
    setHealthcare(false);
    setbanking(false);
    setsoftware(false);
    setrealestate(true);
    setmedia(false);
    settravel(false);
  };
  const handleClick5 = () => {
    setHealthcare(false);
    setbanking(false);
    setsoftware(false);
    setrealestate(false);
    setmedia(true);
    settravel(false);
  };
  const handleClick6 = () => {
    setHealthcare(false);
    setbanking(false);
    setsoftware(false);
    setrealestate(false);
    setmedia(false);
    settravel(true);
  };
  return (
    <div>
      <div>
        <div className="d-flex justify-content-between bg-light mb-4 mt-4 p-3 flex-wrap ">
          <button
            className={` px-4 py-3  ${
              healthcare ? "bg-black text-white " : ""
            } `}
            onClick={handleClick}
          >
            Healthcare
          </button>
          <button
            className={` px-4 py-3  ${banking ? "bg-black text-white " : ""} `}
            onClick={handleClick2}
          >
            Banking
          </button>
          <button
            className={` px-4 py-3  ${software ? "bg-black text-white " : ""} `}
            onClick={handleClick3}
          >
            Software
          </button>
          <button
            className={` px-4 py-3  ${
              realestate ? "bg-black text-white " : ""
            } `}
            onClick={handleClick4}
          >
           Real Estate
          </button>
          <button
            className={` px-4 py-3  ${media ? "bg-black text-white " : ""} `}
            onClick={handleClick5}
          >
            Media
          </button>
          <button
            className={` px-4 py-3  ${travel ? "bg-black text-white " : ""} `}
            onClick={handleClick6}
          >
            Travel
          </button>
        </div>

        <div className="row bg-light  p-4 border ">
          {healthcare && (
            <>
              <div className="col-lg-6">
                <img src={Healthcare} alt="" />
              </div>
              <div className="col-lg-6">
                <h3 className="mb-3 h3-heading ">Healthcare</h3>
                <p className="mb-2 lh-base   h3-para ">
                  Integrating AI app development services transforms the
                  healthcare sector by boosting patient engagement, improving
                  quality, and streamlining operations. At Raiden Labs, we help
                  healthcare providers implement AI into their applications to
                  ensure superior patient care and maintain a competitive edge.
                </p>
               
                <ul className="list-dark fs-6 lh-base ms-2 h3-para">
                  <li>
                    {" "}
                    Sentiment Analysis – To understand patient feedback and
                    emotional tone
                  </li>
                  <li>
                    {" "}
                    AI-Powered Symptom Checker – For early diagnosis and
                    improved patient support
                  </li>
                  <li>
                    NLP-Based Clinical Notes Interpretation – To extract
                    meaningful insights from unstructured medical data
                  </li>
                  <li>
                    Predictive Analytics – For optimized resource allocation and
                    proactive care management
                  </li>
                </ul>
              </div>
            </>
          )}
          {banking && (
            <>
              <div className="col-lg-6">
                <img src={Banking} alt="Banking" />
              </div>
              <div className="col-lg-6">
                <h3 className="mb-3 h3-heading">Banking and Finance</h3>
                <p className="mb-2 lh-base    h3-para">
                  Raiden Labs' cutting-edge AI solutions are designed
                  specifically for the banking and finance sector. Our services
                  help to improve security and deliver smarter solutions. By
                  integrating AI, you transform your platform and stand out in
                  the industry.
                </p>
              
                <ul className="list-dark fs-6 lh-base ms-2  h3-para">
                  <li className="mt-1">
                    {" "}
                    Real-time monitoring of operational changes
                  </li>
                  <li className="mt-1"> Advanced fraud detection systems</li>
                  <li className="mt-1"> AI-powered smart payment solutions</li>
                  <li className="mt-1"> Proactive risk management tools </li>
                </ul>
              </div>
            </>
          )}
          {software && (
            <>
              <div className="col-lg-6">
                <img src={Software_and_Technology} alt="Software and Technology" />
              </div>
              <div className="col-lg-6">
                <h3 className="mb-3 h3-heading">Software and Technology</h3>
                <p className="mb-2 lh-base    h3-para">
                  As a leading AI app development company, Raiden Labs optimizes
                  AI to solve complicated challenges in the IT industry. Our
                  dream is to deliver innovative, effective, and scalable
                  solutions that impress our clients and motivate long-term
                  partnerships. With our skilled team, we help enhance the
                  software and technology industry in the following ways:
                </p>

                <ul className="list-dark fs-6 lh-base ms-2  h3-para">
                  <li className="mt-1"> Personalized Chatbots</li>
                  <li className="mt-1">
                    Predictive Customer Behavior Analysis{" "}
                  </li>
                  <li className="mt-1"> AI-Powered Virtual Assistants </li>
                  <li className="mt-1">
                    {" "}
                    Automated Coding & App Modernization{" "}
                  </li>
                </ul>
              </div>
            </>
          )}
          {realestate && (
            <>
              <div className="col-lg-6">
                <img src={Real_Estate} alt="" />
              </div>
              <div className="col-lg-6">
                <h3 className="mb-3 h3-heading ">Real Estate</h3>
                <p className="mb-2 lh-base    h3-para">
                  Integrating AI in the real estate sector boosts customer
                  experience and allows data-driven decision-making through
                  advanced analytics. As a trusted artificial intelligence app
                  development company, Raiden Labs has a skilled team of AI
                  developers dedicated to transforming real estate operations.
                  We support clients with innovative solutions such as:
                </p>

                <ul className="list-dark fs-6 lh-base ms-2  h3-para">
                  <li className="mt-1"> Efficient Property Management</li>
                  <li className="mt-1">
                    {" "}
                    AI-Powered Content Creation and Curation
                  </li>
                  <li className="mt-1">
                    {" "}
                    Advanced Fraud and Compliance Detection
                  </li>
                  <li className="mt-1"> Smart Data Processing </li>
                </ul>
              </div>
            </>
          )}
          {media && (
            <>
              <div className="col-lg-6">
                <img src={Media} alt="" />
              </div>
              <div className="col-lg-6">
                <h3 className="mb-3 h3-heading ">Media and Entertainment</h3>
                <p className="mb-2 lh-base    h3-para">
                  As a trusted AI development company, we help media and
                  entertainment businesses create content that is effective,
                  engaging, and results-driven. Our focus on delivering high
                  customer satisfaction has placed us as a top AI app
                  development company in the industry.Our AI expertise in media
                  and entertainment includes:
                </p>

                <ul className="list-dark fs-6 lh-base ms-2  h3-para">
                  <li className="mt-1"> Customized Content Recommendations</li>
                  <li className="mt-1">
                    {" "}
                    Automated Content Development & Management
                  </li>
                  <li className="mt-1">
                    AI-Based Translation & Subtitling Tools
                  </li>
                  <li className="mt-1"> Intelligent Visual Enhancement</li>
                </ul>
              </div>
            </>
          )}
          {travel && (
            <>
              <div className="col-lg-6">
                <img src={Travel} alt="Travel" />
              </div>
              <div className="col-lg-6">
                <h3 className="mb-3  h2-heading ">Travel and Transportation</h3>
                <p className="mb-2 lh-base    h3-para">
                  As a trusted AI development company, Raiden Labs helps expand
                  your business opportunities in the travel and transportation
                  industries, which also deliver quality product that helps to
                  manage your routine functions and reduce human error
                </p>

                <ul className="list-dark fs-6 lh-base ms-2  h3-para">
                  <li className="mt-1"> Detection of Insurance Fraud </li>
                  <li className="mt-1"> AI-Powered Chatbots </li>
                  <li className="mt-1"> Vehicle Monitoring </li>
                  <li className="mt-1"> Autonomous Vehicle Technology </li>
                </ul>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CoreComponent29;
